import { render, staticRenderFns } from "./EHistoricoDePagamentos.vue?vue&type=template&id=e3145b64&scoped=true"
import script from "./EHistoricoDePagamentos.vue?vue&type=script&lang=js"
export * from "./EHistoricoDePagamentos.vue?vue&type=script&lang=js"
import style0 from "./EHistoricoDePagamentos.vue?vue&type=style&index=0&id=e3145b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3145b64",
  null
  
)

export default component.exports